module.exports = __webpack_public_path__ + "static/media/ad.a7959c67.svg";